import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function FacebookDownloader() {
  useEffect(() => {
    document.title = 'Facebook Video Downloader — Download Facebook Videos in HD Free';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Download Facebook videos in HD quality for free. Save videos from Facebook posts, pages, and groups as MP4 files.');

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: 'How to Download Facebook Videos',
      step: [
        { '@type': 'HowToStep', position: 1, text: 'Find the Facebook video, click the three dots, and select "Copy link".' },
        { '@type': 'HowToStep', position: 2, text: 'Paste the Facebook video URL into HD Video Download.' },
        { '@type': 'HowToStep', position: 3, text: 'Click Download and save the video in HD quality.' },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <div className="app">
      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>
        <h1 className="page-title">Facebook Video Downloader</h1>
        <p className="page-subtitle">Download Facebook videos in HD quality for free.</p>

        <div className="cta-section" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
          <Link to="/" className="cta-btn">Download Facebook Video Now</Link>
        </div>

        <h2 className="section-title">How to Download Facebook Videos</h2>
        <div className="steps">
          <div className="step"><span className="step-number">1</span><div><h3>Copy Facebook Video Link</h3><p>Find the video on Facebook, click the three dots (⋯) menu, and select "Copy link". Works with fb.watch links too.</p></div></div>
          <div className="step"><span className="step-number">2</span><div><h3>Paste & Download</h3><p>Paste the Facebook URL into hdvideodownload.com and click "Download".</p></div></div>
          <div className="step"><span className="step-number">3</span><div><h3>Save HD Video</h3><p>Choose SD or HD quality and download the video as MP4 to your device.</p></div></div>
        </div>

        <h2 className="section-title">Supported Facebook Content</h2>
        <div className="seo-features">
          <div className="seo-feature"><h3>Public Videos</h3><p>Download videos from public Facebook posts, pages, and groups.</p></div>
          <div className="seo-feature"><h3>HD Quality</h3><p>Save Facebook videos in HD quality when available from the original post.</p></div>
          <div className="seo-feature"><h3>fb.watch Links</h3><p>Supports both facebook.com and fb.watch short URLs for easy downloading.</p></div>
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Download Facebook Videos Free</Link>
        </div>
      </div>
      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default FacebookDownloader;
